"use client";

import { ActivityDisplayPreview } from "./previews";

type HyroxDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function HyroxDisplay({ data, participants }: HyroxDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="hyrox"
      data={data}
      participants={participants}
    />
  );
}
